import { VxeLayoutAside } from 'vxe-pc-ui';
export default {
  name: 'XLayoutSide',
  components: {
    VxeLayoutAside
  }
};